<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from '@/mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '28px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Number,
      // required: true
    },
    index:{
      type:Number
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })

  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el)
      this.setOptions(this.chartData)
    },
    setOptions(option) {
      let opt = Math.round((option*100)*100)/100
      this.chart.setOption({
      grid: {
        top: 20,
        bottom: 0,
        left: 5,
        right: 50
    },
    tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
    title: {
        text: opt+'%',
        top: -5,
        right:45,
        textStyle: {
            fontSize: 14,
            color:"#fff"
        }
    },
    xAxis: {
        show:false,
        type : 'value',
        boundaryGap : [0, 0]
    },
    yAxis: [
        {
            type : 'category',
            data : [''],
            axisLine:{show:false},
            axisTick:[{
                show:false
            }]
        }
    ],
    series: [
        {
            type: 'bar', 
            name: '已完成',
            stack: '总量',
            barMaxWidth: 10,
            label: {
                show: false,
                position: 'inside',
                formatter: '{c}%'
            },
            itemStyle: {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  { offset: 0, color: '#2276FC' },
                  { offset: 0.3, color: 'rgba(41, 186, 232, 0.6)' },
                  { offset: 1, color: 'rgba(104, 145, 239, 0)' },
                ]),
            },
            data: [opt]
        },
        {
            type: 'bar', 
            name: '未完成',
            stack: '总量',
            barMaxWidth: 10,
            label: {
                show: false,
                color: '#aaa',
                position: 'inside' ,
                formatter: '{c}%'
            },
            showBackground: true,
            backgroundStyle: {
                color: 'rgba(47, 47, 47, 0.6)',
                
            },
            itemStyle: {
                color: 'rgba(47, 47, 47, 0.6)',
                
            },
            silent:true,
            data: [100-opt]
        }
    ]
      })
    }
  }
}
</script>
